/**
 * define global constants, e.g. URL, enum, etc.
 * variable naming rule: TYPE_XXXX
 */
import { AbmHttpMethod, AbmRequestLink } from './types';

// 登录接口
export const URL_IF1 = [
    new AbmRequestLink('login.json', 'login', AbmHttpMethod.POST),
    new AbmRequestLink('logout.json', 'logout', AbmHttpMethod.GET),
];

// Stirng literals
export const ABM_USER = 'abmuser';

export const DATETIME_FORMAT_BASIC = 'YYYYMMDDHHmmss';
export const DATETIME_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss.sssZ';
export const DATETIME_FORMAT_YYYYMMDD = 'YYYYMMDD';
